<template>
  <el-menu class="channels-settings-nav">
    <el-menu-item
      class="main-items"
      :key="index"
      v-for="(item, index) in items"
      :index="index.toString()"
    >
      <template slot="title">
        <div class="item-title-container">
          <span>{{ item.title }}</span>
          <div class="channel-status-container">
            <div
              @click="item.click ? item.click() : null"
              :class="item.click ? 'clickable' : ''"
            >
              <i :class="item.icon || 'el-icon-empty-icon empty-icon'"></i>
              <span>{{ item.status }}</span>
            </div>
            <span v-if="item.actions">
              <slot
                name="actions"
                :prop="item.prop"
                :channel="item.channel"
              ></slot>
            </span>
          </div>
        </div>
      </template>
    </el-menu-item>
  </el-menu>
</template>
<script>
export default {
  name: 'ChannelsMenu',

  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.channels-settings-nav {
  border: 1px solid #dbdee7;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  /deep/ .el-icon-empty-icon {
    margin-left: 3px;
    margin-right: 8px;
  }
  /deep/ .empty-icon {
    background: #e6e6e6;
    width: 18px;
    height: 18px;
    border-radius: 9px;
  }

  /deep/ .el-menu-item {
    cursor: default;
  }

  .el-icon-success {
    color: #1fca10;
  }
  .el-icon-error {
    color: #f56c6c;
  }

  .el-icon-info {
    color: #909399;
  }

  .el-icon-warning {
    color: #e6a23c;
  }

  .main-items:not(:last-child) {
    box-shadow: inset 0 -1px 0 #f2f2f2;
  }

  .item-title-container {
    display: flex;
    justify-content: space-between;
  }

  .channel-status-container {
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .channel-status-container .clickable {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/ChannelsMenu.vue